import QuestionDTO from "../DTO/questionDTO"
import QuestionChoiceDTO from "../DTO/questionChoiceDTO"
import PointerChoiceDTO from "@/app/exercise/components/question/core/DTO/pointerChoiceDTO";
import {LAYOUT_OPTIONS_QUERY} from "@/app/exercise/components/question/core/question-const";

const MAX_POINTER_COUNT = 10;

export default class QuestionItem {
  page = null;

  constructor(item = {}) {
    Object.assign(this, new QuestionDTO(item))
    this.page = item.page || null;
    this.choices = this.choices.map(choice => new QuestionChoiceDTO(choice));
    this.pointers = this.pointers.map(pointer => new PointerChoiceDTO(pointer));
    this._apiAttributes = {
      name: 'name',
      category: 'categoryId',
      choices: 'choices',
      numeric_answer: 'numeric_answer',
      measurement_units: 'measurement_units',
    }

    this._mapPointerCount = MAX_POINTER_COUNT;

    this._apiAttributesNested = {
      chapters: {
        name: 'name',
      },
    }

  }

  get newPointerValue() {
    if (!this.pointers || !this.pointers.length) return 1;
    if (this._maxPointerValue > this.pointers.length) {
      for (let index = 1; index < this._maxPointerValue; index++) {
        if (!this.pointers.map(pointer => pointer.value).includes(index)) {
          return index;
        }
      }
    } else {
      return this._maxPointerValue + 1;
    }
  }

  get _maxPointerValue() {
    return Math.max.apply(Math, this.pointers.map(pointer => pointer.value));
  }

  removeQuestionChoiceByIndex(index) {
    this.choices.splice(index, 1);
  }

  addNewChoice() {
    this.choices.push(new QuestionChoiceDTO());
  }

  addNewPointer({x, y, value}) {
    if (this.pointers.length < this._mapPointerCount) {
      this.pointers.push(new PointerChoiceDTO({x, y, value}));
    }
    this.pointers.sort((a,b) => a.value - b.value);
  }

  deletePointer({ value }) {
    this.pointers = this.pointers.filter(pointer => pointer.value !== value);
  }

  deleteAllPointers() {
    this.pointers = [];
  }

  isValid() {
    let valid = true,
      requiredFields = [
        this.name,
        this.categoryId,
        this.choices,
      ]
    requiredFields.forEach(field => {
      if(!field) valid = false
    })
    return valid
  }

  validate (validator) {
    validator.resetFields();
    if (![
      LAYOUT_OPTIONS_QUERY.DRAG_AND_DROP,
      LAYOUT_OPTIONS_QUERY.THEORIE,
      LAYOUT_OPTIONS_QUERY.VIDEO,
      LAYOUT_OPTIONS_QUERY.NUMERIC
    ].includes(this.layout)) {
      this.validateAnswers(validator);
    }
    if(this.layout === LAYOUT_OPTIONS_QUERY.PICTURE_SELECT) {
      this.validatePictures(validator);
      this.validatePicturesCount(validator);
    }

    this.validateLicenseTypes(validator);
    return validator.isValid();
  }

  validateAnswers(validator) {
    if (this.choices.map(choice => choice.isRight).includes(true)) return;
    validator.invalidField('answers', 'At least one answer should be selected as right');
  }

  validatePicturesCount(validator) {
    if (this.choices.length < 2) {
      validator.invalidField('pictures', 'At least two answers should be added');
    }
    if(this.choices.length > 4) {
      validator.invalidField('pictures', 'Maximum 4 answers can be added');
    }
  }

  validatePictures(validator) {
    if (this.choices.every(choice => !!choice.picture)) return;
    validator.invalidField('pictures', 'All answers should have pictures uploaded');
  }

  validateLicenseTypes(validator) {
    if (!this.is_motor && !this.is_auto && !this.is_scooter) {
      validator.invalidField('licenseTypes', 'At least one license type should be selected');
    }
  }

  setChoicePicture(choiceIdx, file) {
    this.choices = this.choices.map((choice, idx) => {
      return new QuestionChoiceDTO({
        ...choice,
        is_right: choice.isRight,
        picture: idx === choiceIdx ? file : choice.picture,
      });
    })
  }

  get isVideoThumbnail() {
    return this.thumbnail && this.thumbnail.endsWith('.mp4');
  }

  getApiData() {
    return {
      name: this.name,
      content: this.content,
      comment: this.comment,
      thumbnail: this.thumbnail,
      category: this.categoryId,
      layout: this.layout,
      video: this.video ? this.video : undefined,
      video_file: this.video_file,
      type: this.type,
      // practice_chapters: this.practice_chapters,
      // theorie_chapters: this.theorie_chapters,
      choices: this._getChoices(),
      pointers: this._getPointers(),
      numeric_answer: this.numeric_answer ? parseFloat(this.numeric_answer) : null,
      is_motor: this.is_motor,
      is_auto: this.is_auto,
      is_scooter: this.is_scooter,
      show_multiple_answers_hint: this.show_multiple_answers_hint,
      measurement_units: this.layout === LAYOUT_OPTIONS_QUERY.NUMERIC ? this.measurement_units ?? '' : '',
    }
  }

  _getPointers() {
    return this.pointers.map(pointer => {
      return {
        x: pointer.coordinates.x,
        y: pointer.coordinates.y,
        value: pointer.value,
      };
    });
  }

  _getChoices() {
    const choices = this.choices.filter(choice => choice.title || choice.picture);
    return choices.map(choice => {
      return {
        id: choice.id,
        title: choice.title,
        is_right: choice.isRight,
        picture: choice.picture,
      }
    })
  }

  _getClearChoices() {
    const choices = this.choices.filter(choice => choice.title || choice.picture);
    return choices.map(choice => {
      return {
        title: choice.title,
        is_right: choice.isRight,
        picture: choice.picture,
      }
    })
  }
}
